import { Flex } from "@aircall/tractor";

import { TagsListProps } from "./TagsList.decl";
import { TagsListItem } from "./TagsListItem";

export function TagsList({ tags }: TagsListProps) {
  return (
    <Flex data-test="tags-list" gap="xxs" flexWrap="wrap">
      {tags.map((tag) => (
        <TagsListItem
          color={tag.color}
          name={tag.name}
          id={tag.id}
          key={tag.id}
        />
      ))}
    </Flex>
  );
}
